module.exports = __webpack_public_path__ + "img/wysd-logo.a468a6e5.png";